module.exports = __webpack_public_path__ + "static/media/instagram_help.6445a094.svg";